import { defineRecipe } from '@chakra-ui/react'

// Field Green Button: tighter radius, weight capped at 600, comfortable 40px /
// compact 32px control height (compact gated by the `compact` condition), accent
// solid = brand. Adds a `link` variant (v3 dropped Chakra's built-in one) so
// inline text links read as links again — see the deferred-v3-calls migration.
//
// NOTE on the `_compact` key: Chakra v3's condition registry always stores a
// custom condition under an underscore-prefixed internal key (see
// createConditions() in styled-system/conditions.js — every entry in
// `defineConfig({ conditions })` is remapped `key -> "_" + key` before being
// registered, exactly like the built-in `hover` config key is consumed as
// `_hover` in style objects). A bare `compact:` key in a recipe style object is
// not recognized as a condition select-or (conditions.has('compact') is false)
// and is silently dropped by the recipe compiler — verified empirically against
// the installed v3.36 (`getRecipeFn('button')({size:'md'})` emits no media rule
// for a bare key, but does for `_compact`). `_compact` is therefore required for
// the density condition to actually apply.
export const buttonRecipe = defineRecipe({
  base: {
    borderRadius: 'sm',
    fontWeight: 600,
  },
  variants: {
    size: {
      // Density layers onto the default sm/md control heights. Applied at
      // both steps (not md-only) so buttons stay consistent with Input/
      // NativeSelect, which needed the same sm+md fix for the common
      // size="sm" call sites (review fix round 1, A6 slice 2 task 2).
      sm: { h: '2.5rem', minH: '2.5rem', _compact: { h: '2rem', minH: '2rem' }, _touch: { h: '2.75rem', minH: '2.75rem' } },
      md: { h: '2.5rem', minH: '2.5rem', _compact: { h: '2rem', minH: '2rem' }, _touch: { h: '2.75rem', minH: '2.75rem' } },
    },
    variant: {
      link: {
        h: 'auto',
        minH: 'auto',
        px: 0,
        color: 'brand.fg',
        fontWeight: 600,
        textDecoration: 'none',
        _hover: { textDecoration: 'underline' },
      },
    },
  },
})
